import Vue from 'vue'
import App from './App.vue'
import CredentialsStore from './store/credentials-store'
import VueRouter from 'vue-router'
import Login from './components/Login.vue'
import Loading from './components/Loading.vue'
import Search from './components/Search.vue'
import Arborescence from './components/Arborescence.vue'
import Linked from './components/Linked.vue'
import OfficeAuthenticationFailed from './components/OfficeAuthenticationFailed.vue'
import LysiasApiMixin from './mixins/LysiasApiMixin'
import SettingsMixin from './mixins/SettingsMixin'

const { push } = VueRouter.prototype
const { isNavigationFailure, NavigationFailureType } = VueRouter


Vue.config.devtools = true;

const routes = [
  { name: 'loading', path: '/loading', component: Loading, props: true },
  { name: 'search', path: '/search', component: Search },
  { name: 'linked', path: '/linked', component: Linked, props: true },
  { name: 'arborescence', path: '/arborescence/:isLinked', component: Arborescence, props: true },
  { name: 'office-auth-failed', path: '/office-auth-failed', component: OfficeAuthenticationFailed },
]
const router = new VueRouter({
  routes: routes,
  mode: 'abstract',
})

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function (location: any) {
  return (originalPush.call(this, location) as unknown as Promise<any>).catch(
    (error: any) => {
      if (!isNavigationFailure(error, NavigationFailureType.duplicated)) {
        throw error;
      }
    }
  );
};

Vue.use(VueRouter)
Vue.mixin(LysiasApiMixin)
Vue.mixin(SettingsMixin)

Vue.config.productionTip = false
Office.onReady(() => {

    new Vue({
        store: CredentialsStore,
        render: h => h(App),
        router: router,
        data: {
            htmlClasses: 'h-100',
        },
    }).$mount('#app')

    console.log('iteminits');
    router.replace('search');
});
